import { Store, Map, BarChart3, Settings, LogOut, MapPinPlus, Route, Shield } from 'lucide-react';

const tabs = [
  { id: 'lojas', label: 'Lojas', icon: Store },
  { id: 'avisitar', label: 'A Visitar', icon: MapPinPlus },
  { id: 'mapa', label: 'Mapa', icon: Map },
  { id: 'rotas', label: 'Rotas', icon: Route },
  { id: 'seguros', label: 'Seguros', icon: Shield },
  { id: 'relatorio', label: 'Relatório', icon: BarChart3 },
  { id: 'config', label: 'Config', icon: Settings },
];

export function BottomNav({ activeTab, onTabChange, onLogout }) {
  const handleLogout = () => {
    if (window.confirm('Deseja sair da sua conta?')) {
      onLogout();
    }
  };

  return (
    <nav 
      data-testid="bottom-nav"
      className="fixed bottom-0 w-full h-16 bg-[var(--bg-header)] flex items-center justify-around z-[10000] shadow-[0_-4px_10px_rgba(0,0,0,0.1)] theme-transition"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            data-testid={`nav-${tab.id}-tab`}
            onClick={() => onTabChange(tab.id)}
            className={`flex flex-col items-center justify-center gap-1 text-[10px] w-full h-full transition-colors ${
              isActive 
                ? 'text-[var(--accent-sky)] font-medium' 
                : 'text-[var(--text-muted)]'
            }`}
          >
            <Icon size={20} strokeWidth={isActive ? 2.5 : 1.5} />
            <span>{tab.label}</span>
          </button>
        );
      })}
      
      {/* Logout Button */}
      <button
        data-testid="nav-logout-btn"
        onClick={handleLogout}
        className="flex flex-col items-center justify-center gap-1 text-[10px] w-full h-full transition-colors text-red-400 hover:text-red-500"
      >
        <LogOut size={20} strokeWidth={1.5} />
        <span>Sair</span>
      </button>
    </nav>
  );
}
